import { TemplateResult, LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { AdoptedStyleSheets } from '../../../controllers/adopted-stylesheets';
import { classMap } from 'lit/directives/class-map.js';
import encapsulatedStyles from './styles/outline-accordion-panel.encapsulated.css?inline';
import globalStyles from './styles/outline-accordion-panel.global.css?inline';
import { OutlineAccordionWrapper } from '../outline-accordion-wrapper/outline-accordion-wrapper';
import '../../outline-svg/outline-svg';


const componentName = 'outline-accordion-panel';

@customElement('outline-accordion-panel')
export class OutlineAccordionPanel extends LitElement {
  adoptedStyleSheets = new AdoptedStyleSheets(this, {
    globalCSS: globalStyles,
    encapsulatedCSS: encapsulatedStyles,
});
    /**
     * If panel is active/open
     */
    @property({ type: Boolean, reflect: true, attribute: true })
    active = false;

    /**
     * Genereated random number for unique ids.
     */
    @property({ type: String, reflect: true })
    id: string = Math.floor(Math.random() * 10000).toString();


    render(): TemplateResult {

        const buttonClasses = {
            'accordion-button': true,
            'active': this.active,
        };

        const iconClasses = {
          'accordion-icon': true,
          'active': this.active,
        };
        
        return html`
            <div class="panel-wrapper" id="${this.id}">
                <div class="panel-heading">
                  <button
                      class="${classMap(buttonClasses)}"
                      id="${this.id}-button"
                      aria-expanded=${this.active}
                      aria-controls="content-${this.id}"
                      @click=${this.setActive}
                      >
                      <span class="accordion-label">
                          <slot @click="${this.passFocus}" name="panel-heading"> </slot>
                      </span>
                      <span class="${classMap(iconClasses)}"> ${this.setIcon()} </span>
                  </button>
                </div>
                <div
                  class="panel-content"
                  aria-labelledby="${this.id}-button"
                  id="content-${this.id}"
                  ?hidden="${!this.active}"
                >
                  <slot name="panel-content"></slot>
                </div>
            </div>
        `;
    }

    setActive() {
        const parentWrapper = this.parentElement as OutlineAccordionWrapper;
        const singlePanel = parentWrapper.singlePanel;
    
        if (singlePanel) {
          const activePanels = [...parentWrapper.panels].filter(
            panel => panel.active == true
          );
    
          if (activePanels.length < 1) {
            this.active = true;
          }
    
          if (activePanels.length > 0) {
            activePanels.map(panel => {
              if (panel.id === this.id) {
                this.active = false;
              } else {
                panel.active = false;
                this.active = true;
              }
            });
          }
        } else {
          this.active = !this.active;
        }
    }

    passFocus() {
        const parentButton = this.querySelector(
            '.accordion-button'
        ) as HTMLButtonElement;
        if (parentButton) {
            parentButton.focus();
        }
    }

    setIcon() {
      return html `<outline-svg name="${this.active ? 'minus' : 'plus'}" size="14px" svg-fill="var(--outline-white)"></outline-svg>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [componentName]: OutlineAccordionPanel;
    }
}
